<template>
  <div class="datatable-container">
    <vs-table ref="table" :data="reviews">
      <template slot="thead">
        <vs-th sort-key="">Product</vs-th>
        <vs-th sort-key="">Username</vs-th>
        <vs-th sort-key="">Review</vs-th>
        <vs-th sort-key="">Rating</vs-th>
        <vs-th sort-key="">Submitted</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ tr.product.title }} <br /> </vs-td>

            <vs-td> {{ tr.username }}<br /> </vs-td>

            <vs-td> {{ tr.comment }} </vs-td>

            <vs-td> {{ tr.rating }} </vs-td>

            <vs-td>{{ tr.createdAt }}</vs-td>

            <vs-td>
                <vs-td class="whitespace-no-wrap">
                    <!--prettier-ignore-->
                    <feather-icon
                        icon="EyeIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click.stop="selectReview(tr)" />
                </vs-td>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <Pagination :total="totalPage" v-model="currentPage" />

    <vs-prompt
        @cancel="rejectSelectedReview"
        @accept="approveSelectedReview"
        @close="showPopup = false"
        accept-text="Approve"
        cancel-text="Reject"
        :active.sync="showPopup"
        :title="`Review from ${selectedReview ? selectedReview.username : ''}`"
    >
        <div class="review-popup-content">
            <div><strong>Product: </strong>{{ selectedReview ? selectedReview.product.title : '' }}</div>
            <div class="pb-4"><strong>Rating: </strong>{{ selectedReview ? selectedReview.rating : '' }}</div>
            <div class="comment">{{ selectedReview ? selectedReview.comment : '' }}</div>
        </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from '@/components/Pagination';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      type: 'REVIEW',
      itemsPerPage: 10,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
      showPopup: false,
      selectedReview: null,
    };
  },
  computed: {
    ...mapState({
        reviews: ({ review }) => review.reviews,
        approveReviewState: ({ review }) => review.apiState.approveReview,
        rejectReviewState: ({ review }) => review.apiState.rejectReview,
    }),
  },
  methods: {
    ...mapActions({
      _getReviews: 'review/getReviews',
      approveReview: 'review/approveReview',
      rejectReview: 'review/rejectReview',
    }),
    getReviews(params) {
      this._getReviews(params)
        .then(response => {
          this.currentPage = parseInt(response.headers['x-pagination-page']);
          this.pageTotal = parseInt(response.headers['x-pagination-count']);
          this.totalItem = parseInt(response.headers['x-pagination-total']);
          this.totalPage = parseInt(response.headers['x-pagination-page-count']);
        })
        .catch(err => {
          console.error({ err });
        });
    },
    selectReview(review) {
        this.selectedReview = review;
        this.showPopup = true;
    },
    approveSelectedReview() {
        if (this.selectedReview) {
            this.approveReview(this.selectedReview.id);
            this.getReviews();
        }
    },
    rejectSelectedReview() {
        if (this.selectedReview) {
            this.rejectReview(this.selectedReview.id);
            this.getReviews();
        }
    },
  },
  async mounted() {
    this.getReviews({
      page: this.currentPage,
      limit: this.itemsPerPage,
      type: this.type,
    });
  },
  watch: {
    async currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = {
          page: this.currentPage,
          limit: this.itemsPerPage,
          type: this.type
        };
        await this.getReviews(params);
      }
    },
  },
};
</script>
<style lang="scss">
.datatable-container {
  .mx-input {
    height: auto;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.01rem;
    padding: 8px;
  }

  td:nth-child(3) > span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    max-width: 500px;
  }
}

.review-popup-content .comment {
    word-break: break-word;
    max-height: calc(100vh - 200px);
    white-space: pre-wrap;
    overflow-y: auto;
    border-top: 1px solid #ededed;
}
</style>
